const INIT_URL = "init_url";
const LOB = "warehouse";
const Datatype = "local";
const baseURLLocal = "http://localhost:8085" ; //"http://192.168.92.253:8085" ||
const baseURLAZUREQA = "https://qawh.azurewebsites.net";
const baseURLAZUREPROD = "https://whprod.azurewebsites.net";
const baseURLDEV = "http://demo.msr-it.com:40114";
const baseURLQA = "http://demo.msr-it.com:40115";
const apitoken = sessionStorage.getItem('token');

const BACKENDCONFIG = getBackendConfig(process.env.REACT_APP_ENV);

const DEFAULT_LIST_VIEW_PAGINATION_OPTIONS = {
  RECORDS_PER_PAGE_OPTIONS: [2, 10, 20, 30],
  DEFAULT_RECORDS_PER_PAGE: 10,
  RECORDS_PER_CACHED_PAGE: 500,
  DEFAULT_ORDERBY: "customer_name",
  SORTBY_ASC: true,
};

const NOTIFICATION_INFO = {
  AUTO_HIDE_DURATION: 3000,
  ERROR_MESSAGE: "Please Try Again Later",
  SUCESS_MESSAGE: "Created Successfully",
  DRAFT_MESSAGE: "Draft Created Successfully",
  EDIT_MESSAGE: "Updated Successfully",
};

const AD_AUTHENTICATION = {
  azureqa: {
    REDIRECT_URL: window.location.origin,
    applicationDebtorURL:"https://app.powerbi.com/view?r=eyJrIjoiYmU2NmMyMTItZTRkNy00YWQ4LTliMjgtMjRkZDk0NjdhNGMyIiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9",
    applicationFinancialsURL : "https://app.powerbi.com/view?r=eyJrIjoiMzRkMjM0MzctZmQxMy00NWJjLTk5NDMtNWQ0NzM5MjVlNzU0IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
  },
  Production: {
    CLIENT_ID: "24133d54-b175-49b4-99bf-83fc691b7b9b",
    TENANT_ID: "1a736ba6-2f25-4dae-96db-4d3aef897a60",
    REDIRECT_URL: window.location.origin,
    applicationDebtorURL:"https://app.powerbi.com/view?r=eyJrIjoiYmU2NmMyMTItZTRkNy00YWQ4LTliMjgtMjRkZDk0NjdhNGMyIiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9",
    applicationFinancialsURL : "https://app.powerbi.com/view?r=eyJrIjoiMzRkMjM0MzctZmQxMy00NWJjLTk5NDMtNWQ0NzM5MjVlNzU0IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
  },
  local: {
    REDIRECT_URL: window.location.origin,
    applicationDebtorURL:"https://app.powerbi.com/view?r=eyJrIjoiYmU2NmMyMTItZTRkNy00YWQ4LTliMjgtMjRkZDk0NjdhNGMyIiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9",
    applicationFinancialsURL : "https://app.powerbi.com/view?r=eyJrIjoiMzRkMjM0MzctZmQxMy00NWJjLTk5NDMtNWQ0NzM5MjVlNzU0IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
  },
  qa: {
    REDIRECT_URL: window.location.origin,
    applicationDebtorURL:"https://app.powerbi.com/view?r=eyJrIjoiYmU2NmMyMTItZTRkNy00YWQ4LTliMjgtMjRkZDk0NjdhNGMyIiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9",
    applicationFinancialsURL : "https://app.powerbi.com/view?r=eyJrIjoiMzRkMjM0MzctZmQxMy00NWJjLTk5NDMtNWQ0NzM5MjVlNzU0IiwidCI6IjFhNzM2YmE2LTJmMjUtNGRhZS05NmRiLTRkM2FlZjg5N2E2MCJ9"
  },
};

const AD_AUTH_CRED = getAdConfig(process.env.REACT_APP_ENV);

function getAdConfig(env) {
  if (env) {
    return AD_AUTHENTICATION[env];
  } else {
    return AD_AUTHENTICATION["local"];
  }
}

function getBackendConfig(env) {
  if (env === "local") {
    return baseURLLocal;

  } else if (env === "dev") {
    return baseURLDEV;

  } else if (env === "qa") {
    return baseURLQA;
  } else if (env === "azureqa") {
    return baseURLAZUREQA;

  } else if (env === "Production") {
    return baseURLAZUREPROD;

  } else {
    return baseURLLocal;
  }
}

export default {
  INIT_URL,
  LOB,
  Datatype,
  baseURLLocal,
  apitoken,
  BACKENDCONFIG,
  DEFAULT_LIST_VIEW_PAGINATION_OPTIONS,
  NOTIFICATION_INFO,
  baseURLAZUREQA,
  AD_AUTH_CRED,
};
